<template>
  <pop-modal :visible="visible" :isDrag="true" title="销项正数发票代码号码填写、确认" :width="560" height="70" @cancel="handelCancel">
    <div class="wrap">
      <div class="steps">
        <div class="steps-item-container">
          <span class="steps-item-content">销项正数发票代码/号码填写</span>
          <span class="steps-circle activated">1</span>
        </div>
        <div class="line"></div>
        <div class="steps-item-container">
          <span class="steps-item-content">开具</span>
          <span class="steps-circle" :class="step === '2' ? 'activated' : 'not-active'">2</span>
        </div>
      </div>
      <template v-if="step === '1'">
        <div class="describe">
          开具销项负数发票时，您必须找到相对应的销项正数发票。请您在下面填写销项正数发票的发票代码、发票号码
        </div>
        <div class="mt-50">
          <div class="formCode">
            <div class="circle"></div>
            <div>
              <span>输入销项正数发票代码、号码</span>
              <div class="flex mt-20">
                <div class="mr-1">发票代码：<input type="text" v-model="hzTaxBillCode" /></div>
                <div>发票号码：<input type="text" v-model="hzTaxBillNo" /></div>
              </div>
            </div>
          </div>
          <div class="formCode mt-20">
            <div class="circle"></div>
            <div>
              <span>再次输入销项正数发票代码、号码</span>
              <div class="flex mt-20">
                <div class="mr-1">发票代码：<input type="text" v-model="reHzTaxBillCode" /></div>
                <div>发票号码：<input type="text" v-model="reHzTaxBillNo" /></div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-if="step === '2'">
        <div><span>本张发票可以开红字发票！</span> <span>查看发票明细</span></div>
        <div class="info-box">
          <div>发票代码：{{ confirmInfo.taxBillCode }}</div>
          <div>发票号码：{{ confirmInfo.taxBillNo }}</div>
          <div>购方名称：{{ confirmInfo.buyerName }}</div>
          <div>购方税号：{{ confirmInfo.buyerTaxPayerId }}</div>
          <div>购方地址电话：{{ confirmInfo.buyerAddress }}</div>
          <div>购方银行账号：{{ confirmInfo.buyerAccounts }}</div>
          <div>合计金额（不含税）：{{ confirmInfo.totalGoodsPrice }}</div>
          <div>合计税额：{{ confirmInfo.totalTaxPay }}</div>
          <div>开票日期：{{ confirmInfo.taxBillDate }}</div>
          <div>开票人：{{ confirmInfo.drawer }}</div>
          <div>作废标志：{{ confirmInfo.isVoid === 'N' ? '否' : '是' }}</div>
        </div>
      </template>
      <!-- 占位 -->
      <div style="height: 53px; width: 100%"></div>
      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1,
        }"
      >
        <a-button style="margin: 0 20px" type="primary" @click="proStep()" v-if="step === '2'">上一步</a-button>
        <a-button style="margin: 0 20px" type="primary" @click="nextStep()" v-if="step === '1'">下一步</a-button>
        <a-button style="margin: 0 20px" type="primary" @click="handelOk()" v-if="step === '2'">完成</a-button>
        <a-button style="margin: 0 20px" type="primary" @click="handelCancel()">取消</a-button>
      </div>
    </div>
  </pop-modal>
</template>

<script>
import Urls from '@/utils/globel.js'
import { parseParam } from '@/utils/util.js'
export default {
  data() {
    return {
      visible: false,
      step: '1',
      // step: 'first',
      hzTaxBillCode: '', // 发票代码
      hzTaxBillNo: '', // 发票号码
      reHzTaxBillCode: '', // 再次输入发票代码
      reHzTaxBillNo: '', // 再次输入发票号码
      confirmInfo: {}, // 开具发票确认的信息
      resqueTabCode: '', // 再次确认
    }
  },
  methods: {
    show() {
      this.visible = true
    },
    handelCancel() {
      this.visible = false
      this.initHzZpCs()
    },
    // 重置直接开具红字专票参数
    initHzZpCs() {
      this.reportHz = false
      this.tabCode = ''
      this.resqueTabCode = ''
      this.hzTaxBillCode = ''
      this.hzTaxBillNo = ''
      this.step = '1'
    },
    // 重置直接开具红字普通发票参数
    initHzPpCs() {
      this.reHzTaxBillCode = ''
      this.reHzTaxBillNo = ''
      this.resqueTabCode = ''
      this.hzTaxBillCode = ''
      this.hzTaxBillNo = ''
      this.step = '1'
    },
    // 上一步
    proStep() {
      this.step = '1'
    },
    // 下一步
    async nextStep() {
      if (this.hzTaxBillCode === '' || this.hzTaxBillCode !== this.reHzTaxBillCode) {
        // 两次输入数据不同
        this.$error({
          title: '提示',
          content: '两次输入的发票代码不同',
        })
        return
      }
      if (this.hzTaxBillNo === '' || this.hzTaxBillNo !== this.reHzTaxBillNo) {
        // 两次输入数据不同
        this.$error({
          title: '提示',
          content: '两次输入的发票号码不同',
        })
        return
      }
      const params = parseParam({
        taxBillCode: this.hzTaxBillCode,
        taxBillNo: this.hzTaxBillNo,
      })
      const res = await this.$http.post(`${Urls.getNegInvoiceInfo}&${params}`)
      if (res) {
        this.confirmInfo = res.data
        if (Object.values(this.confirmInfo).length === 0) {
          this.$error({
            title: '警告',
            content: '没有此发票',
          })
          return
        }
        this.step = '2'
      }
    },
    // 直接开具红字 普通发票
    handelOk() {
      this.$emit('mapDataToInvoice', 'ptzjkj', this.confirmInfo) // 请求接口
      this.initHzPpCs()
      this.visible = false
    },
  },
}
</script>

<style lang="less" scoped>
.wrap {
  padding: 10px 16px;
  color: #000;
}
.steps {
  display: flex;
  align-items: flex-end;
}
.steps-item-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
}
.steps-item-content {
  // width: 140px;
  text-align: center;
}
.steps-circle {
  display: block;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  color: #fff;
  line-height: 40px;
  text-align: center;
  font-size: 16px;
}
.activated {
  background-color: #00a2ffbd;
}
.not-active {
  background-color: #ccc;
}
.describe {
  padding: 10px 0;
}
.formCode {
  display: flex;
  align-items: baseline;
}
.mt-20 {
  margin-top: 20px;
}
.mt-50 {
  margin-top: 50px;
}
.info-box {
  border: 1px solid #00a2ffbd;
}
</style>
